/**
 * 登录相关API
 */
import request from '@/utils/request'

// 账号密码登录
export function loginByPassword(payload) {
  // payload: { username: string, password: string, wxOpenId?: string }
  return request({
    url: '/uic/auth/login',
    method: 'post',
    data: payload
  })
}

// 商家微信登录（使用XHT-TEST账号）
export function loginByWxBusiness(code) {
  // code: 微信授权code
  return request({
    url: '/uic/auth/login/wx/business',
    method: 'post',
    data: { code },
    needAuth: false
  })
}


